<template lang="pug">
    div
        Button(
            @click="channelTest" 
            type="primary" 
            :loading="isLoading" 
            shape="circle"
            icon="ios-play"
            :disabled="disabled"
        )
</template>

<script>
import { _channelTest } from "@/api/notificationChannels";
export default {
    name: "ChannelTestBtn",
    components: {},
    data() {
        return {
            isLoading: false
        };
    },
    props: { channelData: {}, disabled: { default: false } },
    watch: {},
    created() {},
    mounted() {},
    methods: {
        channelTest() {
            var self = this;
            this.isLoading = true;
            _channelTest(this.channelData)
                .then(res => {
                    self.isLoading = false;
                    self.$Notice.success({
                        title: "Success",
                        desc: `${res.data.message}`
                    });
                })
                .catch(err => {
                    self.isLoading = false;
                    console.log(err);
                    self.$Notice.warning({
                        title: "Failed",
                        desc: `${err.message}`
                    });
                });
        }
    },
    computed: {},
    beforeDestroy() {}
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/NotificationChannels/ChannelTestBtn.vue